import React from "react";
import { useSearchParams } from "react-router-dom";
import { ProgramProvider } from "@/lib/programs";
import { usePageMeta } from "@/lib/usePageMeta";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import TrustedBy from "@/components/sections/TrustedBy";
import Process from "@/components/sections/Process";
import ValueStack from "@/components/sections/ValueStack";
import Services from "@/components/sections/Services";
import Guarantee from "@/components/sections/Guarantee";
import Reviews from "@/components/sections/Reviews";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import Reservation from "@/components/sections/Reservation";
import Locations from "@/components/sections/Locations";
import Footer from "@/components/sections/Footer";
import WhatsappFloat from "@/components/sections/WhatsappFloat";
import StickyCTA from "@/components/sections/StickyCTA";

export default function Landing() {
  usePageMeta({
    title: "Detailing 4 v 1 za 2 999 Kč — Car Spa Praha | Čestlice & Butovice",
    description: "Ruční mytí, dekontaminace laku, strojové leštění a interiér suchou cestou — kompletní program za 2 999 Kč, hotovo do jednoho dne. Spokojenost, nebo peníze zpět.",
    path: "/akce/detailing",
  });
  const [params] = useSearchParams();
  const initialLocation = ["cestlice", "butovice"].includes(params.get("pobocka")) ? params.get("pobocka") : "cestlice";
  return (
    <ProgramProvider initialLocation={initialLocation}>
    <main data-testid="landing-page" className="relative bg-brand-bg text-white">
      <Navbar />
      <Hero />
      <TrustedBy />
      <Process />
      <ValueStack />
      <Services />
      <Guarantee />
      <Reviews />
      <Pricing />
      <FAQ />
      <Reservation />
      <Locations />
      <Footer />
      <WhatsappFloat />
      <StickyCTA />
    </main>
    </ProgramProvider>
  );
}
